import type { ThemePack } from "./types";

// —— 内置主题包 ——
// 想加新皮肤：复制一份，换掉 tiles 即可；逻辑内核与渲染层都不用动。
// 只要保证 tiles 数量足够覆盖最高关卡需要的种类数（10x10 关约需 40+ 种最佳）。

/** 水果零食（忠实还原原版的 48 个 emoji）。 */
export const fruitsPack: ThemePack = {
  id: "fruits",
  name: "水果零食",
  description: "原版风味：48 种美食 emoji",
  background: 0x0f172a,
  boardColor: 0x1e293b,
  emptyCellColor: 0x1b2740,
  tileCardColor: 0xf8fafc,
  beamColor: 0x38bdf8,
  tiles: [
    "🍎", "🍌", "🍇", "🍊", "🍉", "🍒", "🥝", "🍍",
    "🥥", "🍑", "🍓", "🥑", "🍋", "🍄", "🥦", "🌽",
    "🥨", "🥯", "🧇", "🥞", "🥪", "🍕", "🍔", "🍟",
    "🌭", "🌮", "🌯", "🥗", "🍿", "🍱", "🍘", "🍙",
    "🍧", "🍨", "🍦", "🥧", "🧁", "🍰", "🍮", "🍭",
    "🍬", "🍫", "🍩", "🍪", "🧸", "🎈", "⭐", "💎",
  ].map((emoji, i) => ({ id: `fruit-${i}`, emoji })),
};

/** 动物园（同为 emoji 策略，换一套字形即换一个游戏观感）。 */
export const animalsPack: ThemePack = {
  id: "animals",
  name: "动物乐园",
  description: "换一套 emoji 就像换了个游戏",
  background: 0x14210f,
  boardColor: 0x1f3d1a,
  emptyCellColor: 0x24331b,
  tileCardColor: 0xf7fee7,
  beamColor: 0x84cc16,
  tiles: [
    "🐶", "🐱", "🐭", "🐹", "🐰", "🦊", "🐻", "🐼",
    "🐨", "🐯", "🦁", "🐮", "🐷", "🐸", "🐵", "🐔",
    "🐧", "🐦", "🐤", "🦆", "🦅", "🦉", "🦇", "🐺",
    "🐗", "🐴", "🦄", "🐝", "🐛", "🦋", "🐌", "🐞",
    "🐢", "🐍", "🦎", "🐙", "🦑", "🦀", "🐠", "🐳",
    "🦈", "🐊", "🦓", "🦍", "🐆", "🐘", "🦏", "🐫",
  ].map((emoji, i) => ({ id: `animal-${i}`, emoji })),
};

/** 宝石（程序化色块策略：完全不依赖 emoji / 图片，用纯色圆角块 + 着色）。 */
export const gemsPack: ThemePack = {
  id: "gems",
  name: "霓虹宝石",
  description: "无美术资源也能玩：程序化色块",
  background: 0x0b0f1a,
  boardColor: 0x151b2e,
  emptyCellColor: 0x1a2138,
  tileCardColor: 0x1a2138,
  beamColor: 0xffffff,
  tiles: [
    0xef4444, 0xf97316, 0xf59e0b, 0xeab308, 0x84cc16, 0x22c55e, 0x10b981, 0x14b8a6,
    0x06b6d4, 0x0ea5e9, 0x3b82f6, 0x6366f1, 0x8b5cf6, 0xa855f7, 0xd946ef, 0xec4899,
    0xf43f5e, 0xffffff, 0x94a3b8, 0x64748b,
  ].map((tint, i) => ({ id: `gem-${i}`, shape: "rounded" as const, tint })),
};

/** 主题注册表：这里出现的都能在 UI 里被选中。 */
export const THEME_PACKS: readonly ThemePack[] = [fruitsPack, animalsPack, gemsPack];

export const DEFAULT_THEME_ID = fruitsPack.id;

export function getThemePack(id: string): ThemePack {
  return THEME_PACKS.find((p) => p.id === id) ?? fruitsPack;
}
